import PropTypes from 'prop-types'
import { propTypes } from '../../helpers'
import { Link, useParams } from 'react-router-dom'
import { Button, Col, Container, Row } from 'react-bootstrap'
import {
  ContentPanel,
  LoginImage,
  LogoImage,
  StoryGrid
} from '../../components'
import { useStories } from '../../hooks'
import {
  useActions,
  useApplicationName,
  useImgAltLogin,
  useImgAltLogo,
  useImgSrcLogin,
  useImgSrcLogo
} from '../../store'
import { Helmet } from 'react-helmet-async'

const LoginPage = ({ category, onLogin }) => {
  const { tenantUrlSlug, affiliationUrlSlug, categoryUrlSlug, id } = useParams()
  const applicationName = useApplicationName()
  const imgSrcLogin = useImgSrcLogin()
  const imgAltLogin = useImgAltLogin()
  const imgSrcLogo = useImgSrcLogo()
  const imgAltLogo = useImgAltLogo()
  const { setError } = useActions()
  const { stories } = useStories(category.id)

  const selectedStory = stories?.find((it) => it.id === Number(id))
  if (stories && id && !selectedStory) {
    setError(`Story not found`)
  }

  return (
    <Container className='resizing-container' fluid={!selectedStory}>
      <Helmet>
        <title>Login - {applicationName}</title>
      </Helmet>
      <ContentPanel className='login-panel p-0'>
        <Row>
          <Col
            className='pb-3'
            xs={{ span: 12, order: 1 }}
            md={{ span: 6, order: 1 }}
          >
            <Row className='h-75 justify-content-center'>
              <LogoImage fluid src={imgSrcLogo} alt={imgAltLogo} />
              <h1 className='sr-only'>Login - {applicationName}</h1>
            </Row>
            <Row className='justify-content-center'>
              <Button variant='primary' onClick={onLogin}>
                Log In
              </Button>
            </Row>
          </Col>
          <Col
            className='login-col-img'
            xs={{ span: 12, order: 0 }}
            md={{ span: 6, order: 2 }}
          >
            <LoginImage src={imgSrcLogin} alt={imgAltLogin} />
          </Col>
        </Row>
      </ContentPanel>
      {stories ? (
        selectedStory ? (
          <ContentPanel className='story-panel'>
            <Button
              as={Link}
              to={`/${tenantUrlSlug}/${affiliationUrlSlug}/${categoryUrlSlug}`}
              variant='link'
            >
              back
            </Button>
            <div dangerouslySetInnerHTML={{ __html: selectedStory.content }} />
          </ContentPanel>
        ) : (
          <StoryGrid
            stories={stories}
            pathname={`/${tenantUrlSlug}/${affiliationUrlSlug}/${categoryUrlSlug}`}
          />
        )
      ) : null}
    </Container>
  )
}

LoginPage.propTypes = {
  category: propTypes.categoryPropType,
  onLogin: PropTypes.func.isRequired
}

export { LoginPage }
